import themeVariables from './themeVariables';

export default {
  component: themeVariables,
  colors: {
    green0: '#d4ebd0',
    green1: '#3bca96',
    green2: '#26a69a',
    green3: '#24ce88',
    green4: '#72bf63',
    green5: 'rgba(114, 191, 99, 0.8)',
    green6: 'rgba(59, 202, 150, 0.87)',
    green7: '#7ac142',
    green8: '#66ab59',
    green9: 'rgba(114, 191, 99, 0.3)',
    green10: 'rgba(114, 191, 99, 0.2)',
    blue1: '#088482',
    blue2: '#2580BC', //5399c8
    blue3: '#2980BB',
    blue4: 'rgba(143, 215, 251, 0.3)',
    blue5: 'rgba(0, 136, 204, 0.8)',
    blue6: 'rgba(66, 154, 213, 0.8)',
    blue7: 'rgba(37, 128, 188, 0.9)',
    blue8: 'rgba(37, 128, 188, 0.5)',
    blue9: 'rgba(37, 128, 188, 0.15)',
    blue10: 'rgba(0, 136, 204, 0.5)',
    blue11: '#c5ebff',
    blue12: '#088482',
    blue13: 'rgba(8, 132, 130, 0.5)',
    orange1: '#ffa000',
    orange2: '#ffc768',
    orange3: 'rgba(255, 160, 0, 0.8)',
    orange4: 'rgba(255, 179, 51, 0.8)',
    orange5: 'rgba(255, 179, 51, 0.5)',
    orange6: '#ffc562',
    red1: '#f54',
    red2: 'rgba(188, 0, 2, 0.87)',
    red3: 'rgba(255,85,68, 0.2)',
    dark1: 'rgba(0,0,0,0.8)',
    dark2: '#333',
    dark3: '#555',
    white: '#fff',
    // color codes used directly in css in js
    // name generated by http://chir.ag/projects/name-that-color
    blueWhale: '#042741',
    catskillWhite: '#EEF2F6',
    horizon: '#6089A8',
  },
};
